module.exports = __webpack_public_path__ + "static/NBInternationalPro-Reg-12494769f3e367e347d1b60cac64a17a.woff";